import { Dropdown } from "flowbite-react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import type { ThunkDispatch } from "redux-thunk";

import Logo from "../../../assets/images/logo.svg";
import { RoleTypeExtension } from "../../constants";
import { currentUserActions } from "../../reducers/currentUser";
import { HamburgerIcon, LogoutIcon } from "../SVGIcons";

interface RootState {
  currentUser: {
    userName?: string;
    planType?: string;
    roleType?: string;
    is_staff?: boolean;
    [key: string]: unknown;
  };
}

function mapStateToProps(state: RootState) {
  return {
    userName: state.currentUser.userName,
    planType: state.currentUser.planType,
    roleType: state.currentUser.roleType,
    isStaff: state.currentUser.is_staff,
  };
}

interface GeneralUserManageNavBarProps {
  userName?: string;
  planType?: string;
  roleType?: string;
  isStaff?: boolean;
}

const GeneralUserManageNavBar = ({
  userName,
  planType,
  roleType,
  isStaff,
}: GeneralUserManageNavBarProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<RootState, unknown, unknown>>();
  const [searchParams] = useSearchParams();
  const accountId = searchParams.get("account_id");
  const isViewer = RoleTypeExtension.isViewer(roleType);

  const goToApp = () => {
    navigate("/");
  };

  const signOutUser = () => {
    dispatch(currentUserActions.signOutUser(navigate));
  };

  return (
    <header className="sticky top-0 z-40 w-full backdrop-blur flex-none transition-colors duration-500 lg:z-50 lg:border-b lg:border-slate-900/10 bg-white supports-backdrop-blur:bg-white/95">
      <div className="max-w-8xl mx-auto py-4 border-b border-slate-900/10 lg:px-8 lg:border-0 mx-4 lg:mx-0 flex items-center h-14">
        {/* 左端: ロゴ */}
        <div className="flex gap-2 items-center">
          <h1>
            <button type="button" onClick={() => navigate("/")}>
              <img src={Logo} alt="" className="max-h-10" />
            </button>
          </h1>
        </div>

        {/* 右端: ナビゲーションメニュー */}
        <div className="flex ml-auto absolute top-2 right-[2rem]">
          <nav>
            <div className="flex items-center mx-auto">
              {!isViewer && (
                <button
                  type="button"
                  onClick={goToApp}
                  className="mr-4 px-3 py-2 text-sm text-gray-700 hover:text-blue-700 hover:underline"
                >
                  {accountId ? "管理者画面に戻る" : "アプリに戻る"}
                </button>
              )}

              <Dropdown
                label=""
                renderTrigger={() => (
                  <button
                    type="button"
                    className="inline-flex items-center p-2 h-10 justify-center text-sm text-gray-500 rounded-lg hover:bg-gray-100"
                  >
                    {planType && !isStaff && (
                      <span className="mr-2 px-2 py-1 text-xs font-semibold text-white bg-orange-500 rounded-full">
                        {planType}プラン
                      </span>
                    )}
                    <span className="mr-2">{userName}</span>
                    <HamburgerIcon />
                  </button>
                )}
              >
                <div className="absolute right-[-1.9rem] top-0 min-w-64 p-4 border border-gray-100 rounded-b-lg bg-gray-50 flex flex-col min-h-[5rem] drop-shadow-md">
                  <button
                    type="button"
                    onClick={signOutUser}
                    className="flex py-2 px-3 rounded text-gray-900 hover:bg-gray-100 mt-auto gap-1 items-center"
                  >
                    <LogoutIcon />
                    ログアウト
                  </button>
                </div>
              </Dropdown>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default connect(mapStateToProps)(GeneralUserManageNavBar);
